export default __webpack_public_path__ + "static/media/gallery_03.43532462.jpg";